export default function Logo({ dark = false, compact = false }) {
  const title = dark ? "text-white" : "text-navy";
  const sub = dark ? "text-white/60" : "text-body";
  return (
    <a href="#home" data-testid="navbar-logo" className="inline-flex items-center gap-3 group" aria-label="Paras Real Estate — Home">
      <span className="relative block w-10 h-10 shrink-0">
        <svg viewBox="0 0 64 64" className="w-10 h-10" aria-hidden="true">
          <rect width="64" height="64" rx="14" fill="#0A192F" />
          <path d="M20 50V15h12.5a11.5 11.5 0 0 1 0 23H26" fill="none" stroke="#C5A059" strokeWidth="5" strokeLinecap="square" />
          <rect x="40" y="42" width="7" height="7" fill="#D4AF37" />
          <rect x="40" y="34" width="7" height="7" fill="#C5A059" opacity="0.55" />
        </svg>
        <span className="absolute inset-0 rounded-[14px] ring-1 ring-gold/0 group-hover:ring-gold/60 transition-shadow duration-300" />
      </span>
      {!compact && (
        <span className="leading-none">
          <span className={`block font-serif text-2xl font-semibold tracking-wide ${title}`}>Paras</span>
          <span className={`block font-mono text-[9px] uppercase tracking-[0.34em] mt-1 ${sub}`}>Real Estate · Dholera</span>
        </span>
      )}
    </a>
  );
}
